import { useEffect, useState } from "react";
import { seasonSentence, seasonStatus } from "@/lib/season";
import { cn } from "@/lib/utils";

/**
 * "Is it tick season right now?" for a peak-season string.
 *
 * Computed after mount, from the reader's own clock: these pages are server-rendered and
 * cached, so a date baked into the HTML would be wrong the day after it was built, and a
 * server/client month mismatch would break hydration.
 */
export function SeasonNow({ peakSeason, className }: { peakSeason: string; className?: string }) {
  const [sentence, setSentence] = useState<string | null>(null);

  useEffect(() => {
    setSentence(seasonSentence(seasonStatus(peakSeason, new Date())));
  }, [peakSeason]);

  if (!sentence) return null;
  return <p className={cn("text-sm text-foreground", className)}>{sentence}</p>;
}
